module.exports = __webpack_public_path__ + "static/media/work-day-scheduler.5bf7a838.png";